<template>
  <div class="ml-4">
    <div class="d-flex align-center flex-nowrap">
      <span class="mr-2 text-caption">{{ $t('altitude.relative') }}</span>
      <span class="mr-2 text-caption">
        <div v-if="altitudeData" style="display: flex; flex-direction: column">
          <span>{{
            $t('altitude.maxM', { value: formatAltitude(altitudeData.maxAltitude) })
          }}</span>
          <span>{{
            $t('altitude.avgM', { value: formatAltitude(altitudeData.avgAltitude) })
          }}</span>
          <span>{{
            $t('altitude.minM', { value: formatAltitude(altitudeData.minAltitude) })
          }}</span>
        </div>
        <div v-else>-</div>
      </span>
      <v-icon class="mr-2" color="primary">mdi-plus-circle</v-icon>
      <span class="mr-2 text-caption">&nbsp;{{ $t('altitude.correction') }}</span>
      <v-text-field
        :value="relativeHeightAdjustment"
        hide-details="auto"
        dense
        placeholder="0"
        default="0"
        outlined
        suffix="m"
        class="ma-0"
        style="max-width: 85px"
        @input="handleRelativeHeightChange"
        @blur="handleRelativeHeightBlur"
      />
      <template v-if="cameraPitch !== null && cameraPitch !== undefined">
        <v-icon class="mx-2" small color="grey">mdi-slash-forward</v-icon>
        <span class="mr-1 text-caption">{{ $t('equipment.cameraPitch') }}</span>
        <v-text-field
          :value="cameraPitch"
          type="number"
          min="-90"
          max="90"
          step="1"
          hide-details="auto"
          dense
          suffix="°"
          outlined
          class="ma-0"
          style="max-width: 80px"
          @input="handleCameraPitchChange"
          @blur="handleCameraPitchBlur"
        />
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'altitudeInputFields',
    props: {
      baseAltitude: {
        type: Number,
        default: 0.0
      },
      relativeHeightAdjustment: {
        type: Number,
        default: 0.0
      },
      altitudeData: {
        type: Object,
        default: null,
        validator(value) {
          return (
            value === null ||
            (typeof value === 'object' &&
              ('avgAltitude' in value || 'minAltitude' in value || 'maxAltitude' in value))
          );
        }
      },
      cameraPitch: {
        type: Number,
        default: null
      }
    },
    computed: {
      finalAltitude() {
        const base = parseFloat(this.baseAltitude) || 0;
        const adjustment = parseFloat(this.relativeHeightAdjustment) || 0;
        return (base + adjustment).toFixed(2);
      }
    },
    methods: {
      handleBaseAltitudeChange(value) {
        const numValue = parseFloat(value) || 0;
        this.$emit('update:baseAltitude', numValue);
      },
      handleBaseAltitudeBlur(event) {
        const numValue = parseFloat(event.target.value) || 0;
        this.$emit('update:baseAltitude', numValue);
      },
      handleRelativeHeightChange(value) {
        const numValue = parseFloat(value) || 0;
        this.$emit('update:relativeHeightAdjustment', numValue);
      },
      handleRelativeHeightBlur(event) {
        const numValue = parseFloat(event.target.value) || 0;
        this.$emit('update:relativeHeightAdjustment', numValue);
      },
      handleCameraPitchChange(value) {
        const numValue = Number(value);
        if (!Number.isFinite(numValue)) return;
        this.$emit('update:cameraPitch', Math.max(-90, Math.min(90, Math.round(numValue))));
      },
      handleCameraPitchBlur(event) {
        const raw = event?.target?.value;
        if (raw === '' || raw === null || raw === undefined) {
          this.$emit('update:cameraPitch', -90);
          return;
        }
        this.handleCameraPitchChange(raw);
      },
      formatAltitude(altitude) {
        if (altitude === null || altitude === undefined) {
          return '-';
        }
        return parseFloat(altitude).toFixed(2);
      }
    }
  };
</script>

<style scoped></style>
